var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "panel-filter-group b-shadow-1" },
    [
      _c(
        "h2",
        {
          class: { isOpen: _vm.isOpen },
          attrs: { id: _vm.titleId },
          on: {
            click: function($event) {
              _vm.isOpen = !_vm.isOpen
            }
          }
        },
        [_c("i"), _vm._v(_vm._s(_vm.title))]
      ),
      _vm._v(" "),
      _vm._t("default")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// C:/Code/mappingnhn/web/app/themes/mapping/node_modules/vue-loader/lib/loaders/templateLoader.js?{}!C:/Code/mappingnhn/web/app/themes/mapping/node_modules/vue-loader/lib?{}!./scripts/vue/PanelFilterGroup.vue?vue&type=template&id=e2407712&
// module id = 79
// module chunks = 0